import { render, staticRenderFns } from "./editpreschooldetails.vue?vue&type=template&id=6d3dcb89&scoped=true"
import script from "./editpreschooldetails.vue?vue&type=script&lang=js"
export * from "./editpreschooldetails.vue?vue&type=script&lang=js"
import style0 from "./editpreschooldetails.vue?vue&type=style&index=0&id=6d3dcb89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3dcb89",
  null
  
)

export default component.exports